/** Full page reload — isolated so it can be mocked in tests (jsdom forbids redefining location.reload). */
export const reloadPage = (): void => {
	globalThis.location.reload()
}
